import {useContext} from "react";
import {PreloaderContext} from "../context/PreloaderContext";

export function usePreloader(): { setLoading: (loading: boolean) => void } {
    const sidebarHelpers = useContext(PreloaderContext);
    return sidebarHelpers;
}
